import React, { useState } from 'react';
import { useProfile } from '../contexts/ProfileContext';
import { POWERUPS } from '../economy/economyCatalog';
import CoinIcon from './icons/CoinIcon';
import AddCoinsPill from './coins/AddCoinsPill';
import './SkipButton.css';

const SkipButton = ({ onSkip, disabled, freeSkipsRemaining = 0 }) => {
  const { coins } = useProfile();
  const [isProcessing, setIsProcessing] = useState(false);
  const SKIP_COST = POWERUPS.skip.uiCostCoins;

  const handleSkip = async () => {
    if ((freeSkipsRemaining <= 0 && coins < SKIP_COST) || disabled || isProcessing) {
      return;
    }
    
    setIsProcessing(true);
    await onSkip();
    setIsProcessing(false);
  };

  const canAfford = freeSkipsRemaining > 0 || coins >= SKIP_COST;
  const showAddCoins = freeSkipsRemaining <= 0 && coins < SKIP_COST;

  const costLabel = freeSkipsRemaining > 0 ? `Free: ${freeSkipsRemaining}` : null;
  const costClass =
    freeSkipsRemaining > 0 ? 'cost-indicator free' : 'cost-indicator';

  const disableMainAction = !canAfford || disabled || isProcessing;
  // IMPORTANT: when user is broke, don't use the HTML "disabled" attribute,
  // otherwise the embedded "Add Coins" pill cannot be clicked.
  const useNativeDisabled = disableMainAction && !showAddCoins;

  return (
    <div className="skip-button-wrap">
      <button
        className={`skip-button ${disableMainAction ? 'disabled' : ''} ${showAddCoins ? 'add-coins-state' : ''}`.trim()}
        onClick={handleSkip}
        disabled={useNativeDisabled}
        aria-disabled={disableMainAction}
      >
        <span className="label">{isProcessing ? 'Processing...' : 'Skip'}</span>
        {costLabel ? (
          <span className={costClass}>{costLabel}</span>
        ) : (
          <span className={costClass}>
            {SKIP_COST}
            <CoinIcon />
          </span>
        )}

        {showAddCoins && <AddCoinsPill className="cost-indicator add-coins-pill" />}
      </button>
    </div>
  );
};

export default SkipButton; 